export const API_BASE_URL = 'https://papirrullen.clientdemo.app';
export const SHIPPING_COST = 5.99; // Standard shipping cost in EUR
export const ADMIN_EMAIL = "admin@adservo.net";
